// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { dspProcessingId } from './DspProcessing';
import { fractionTypeEnum8f45884b } from './FractionTypeEnum8f45884b';
import { emulsionStability } from './EmulsionStability';
import { z } from 'zod';
export const formulationId = (z.number());
export const formulation = z.object({
    id: formulationId,
    created_at: z.date(),
    parent_dsp_id: dspProcessingId,
    parent_fraction_type: fractionTypeEnum8f45884b,
    solubility: z.number().nullable(),
    emulsion_stability: emulsionStability.nullable(),
    emulsion_viscosity: z.number().nullable(),
    emulsion_color: z.string().nullable(),
    foaming_t0: z.number().nullable(),
    foaming_t30: z.number().nullable(),
    heat_gelling_sliminess: z.number().nullable(),
    heat_gelling_viscosity: z.number().nullable(),
    acid_gelling_sliminess: z.number().nullable(),
    acid_gelling_viscosity: z.number().nullable(),
    smell_features: z.unknown().nullable(),
    powder_color: z.string().nullable(),
});
export const formulationInitializer = z.object({
    id: formulationId.optional(),
    created_at: z.date().optional(),
    parent_dsp_id: dspProcessingId,
    parent_fraction_type: fractionTypeEnum8f45884b,
    solubility: z.number().optional().nullable(),
    emulsion_stability: emulsionStability.optional().nullable(),
    emulsion_viscosity: z.number().optional().nullable(),
    emulsion_color: z.string().optional().nullable(),
    foaming_t0: z.number().optional().nullable(),
    foaming_t30: z.number().optional().nullable(),
    heat_gelling_sliminess: z.number().optional().nullable(),
    heat_gelling_viscosity: z.number().optional().nullable(),
    acid_gelling_sliminess: z.number().optional().nullable(),
    acid_gelling_viscosity: z.number().optional().nullable(),
    smell_features: z.unknown().optional().nullable(),
    powder_color: z.string().optional().nullable(),
});
export const formulationMutator = z.object({
    id: formulationId.optional(),
    created_at: z.date().optional(),
    parent_dsp_id: dspProcessingId.optional(),
    parent_fraction_type: fractionTypeEnum8f45884b.optional(),
    solubility: z.number().optional().nullable(),
    emulsion_stability: emulsionStability.optional().nullable(),
    emulsion_viscosity: z.number().optional().nullable(),
    emulsion_color: z.string().optional().nullable(),
    foaming_t0: z.number().optional().nullable(),
    foaming_t30: z.number().optional().nullable(),
    heat_gelling_sliminess: z.number().optional().nullable(),
    heat_gelling_viscosity: z.number().optional().nullable(),
    acid_gelling_sliminess: z.number().optional().nullable(),
    acid_gelling_viscosity: z.number().optional().nullable(),
    smell_features: z.unknown().optional().nullable(),
    powder_color: z.string().optional().nullable(),
});
//# sourceMappingURL=Formulation.js.map